import type { AnchorHTMLAttributes, ReactNode } from "react";
import { tv } from "tailwind-variants";

interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  children?: ReactNode;
  sameTab?: boolean;
  href: string;
}

export const linkStyle = tv({
  base: "font-medium text-blue-600 hover:text-blue-500",
});

export function Link({
  children,
  href,
  sameTab,
  ...other
}: LinkProps): ReactNode {
  return (
    <a
      href={href}
      rel={sameTab ? undefined : "noreferrer"}
      target={sameTab ? undefined : "_blank"}
      {...other}
      className={linkStyle()}
    >
      {children}
    </a>
  );
}
